import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=3a257744&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=js"
export * from "./NoticeList.vue?vue&type=script&lang=js"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=3a257744&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a257744",
  null
  
)

export default component.exports